/** encapsulation d'un objet à afficher dans les charts */
export class ChartItemObj {
  public name: string; // le nom unique de l'item
  public label: string; // label de la valeur
  public tooltip: string; // tooltip
  public value: number; // la valeur à restituer
  public formattedValue: string; // la valeur formatée pour affichage
  public extra: any; // on utilise le extra pour passer le formattedValue
  public sortKey: any; // le champ qui sert de tri
  public color: string = null;


  public x: number; // coord x si nécessaire
  public y: number; // coord y si nécessaire
  public r: number; // coord z si nécessaire

  constructor(
    name: string,
    label: string,
    value?: number,
    formattedValue?: string,
    sortKey?: any,
    x?: number,
    y?: number,
    r?: number,
    color?: string
  ) {
    this.name = name;
    this.label = label;
    this.value = value;
    this.formattedValue = formattedValue;
    this.extra = formattedValue;
    this.sortKey = sortKey;
    this.color = color;

    this.x = x;
    this.y = y;
    this.r = r;
  }
}
